import {useShallow} from 'zustand/react/shallow'
import {useConfirmationDialogStore} from './confirmationDialogStore'
import {useFormContext, useWatch} from 'react-hook-form'
import {NotificationUsersConfirmationValidationSchema} from '@/features/users/types'
import {useTheme} from 'styled-components'
import {ConfirmationDialogAccordionButton} from './ConfirmationDialogButton'
import {Flexbox} from '../flexbox/FlexBox'
import {Bell01Icon, ChevronDownIcon, ChevronUpIcon} from '../icon/Icon'
import {Trans} from '@/translations/i18n'
import {Avatar} from '../avatar/Avatar'

export const ConfirmationDialogAccordion = () => {
    const {isAccordionOpen, setIsAccordionOpen} = useConfirmationDialogStore(
        useShallow(state => ({
            accordionType: state.accordionType,
            isAccordionOpen: state.isAccordionOpen,
            setIsAccordionOpen: state.setIsAccordionOpen
        }))
    )

    const form = useFormContext<NotificationUsersConfirmationValidationSchema>()
    const selectedUsers = useWatch({control: form.control, name: 'notificationsRecipients'})
    const theme = useTheme()

    return (
        <ConfirmationDialogAccordionButton
            variant="ghost"
            fullWidth
            onClick={() => setIsAccordionOpen(!isAccordionOpen)}
            shape="text"
        >
            <Flexbox gap={2} align="center">
                <Bell01Icon />
                <p>
                    <Trans
                        i18nKey="users:confirmation_modal_notification"
                        values={{count: selectedUsers?.length || 0}}
                        components={{b: <b />}}
                    />
                </p>
                {selectedUsers && selectedUsers.length > 0 && (
                    <Flexbox align="center">
                        {selectedUsers?.slice(0, 4).map((user, index) => (
                            <Avatar
                                key={user.id}
                                style={{
                                    marginLeft: index > 0 ? -theme.spacing * 2 : 0,
                                    zIndex: 10 - index,
                                    position: 'relative'
                                }}
                                size="xs"
                                name={user.fullName}
                            />
                        ))}
                    </Flexbox>
                )}
            </Flexbox>
            {isAccordionOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
        </ConfirmationDialogAccordionButton>
    )
}
